// extracted by mini-css-extract-plugin
export var columnList = "_cm-0";